import React from "react"
import PropTypes from "prop-types"
import StyledPickerContainer from "./styled/StyledPickerContainer"
import Tray from "./Tray"

export const TrayPicker = ({ currentTray, trays, onClick }) => {
  return (
    <StyledPickerContainer>
      {trays.map(tray => (
        <Tray
          key={tray}
          isActive={currentTray === tray}
          onClick={onClick}
          tray={tray}
        />
      ))}
    </StyledPickerContainer>
  )
}

TrayPicker.propTypes = {
  currentTray: PropTypes.string,
  trays: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
}

export default React.memo(TrayPicker)
